import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C3Position, useC3PositionColumns } from "./columns";
import { type FilterC3PositionsSchema, FilterC3Positions } from "./filter";

export const C3PositionsTable = () => {
  const columns = useC3PositionColumns();
  return (
    <Table<C3Position, FilterC3PositionsSchema>
      label="Positions"
      client={Clients.C3}
      table_name={Tables.C3_POSITIONS}
      columns={columns}
      filter={<FilterC3Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C3}/${Tables.C3_POSITIONS}/new`,
        },
      ]}
    />
  );
};
